import { all, call, put, select, takeEvery } from 'redux-saga/effects'

import * as Actions from 'actions/saved_searches'
import * as Api from 'api/bff'
import * as AppActions from 'actions/app'
import * as Selectors from 'selectors'

const groupBody = group => ({
  name_de: group.get('nameDe') || '',
  name_en: group.get('nameEn') || '',
  name_fr: group.get('nameFr') || '',
  name_it: group.get('nameIt') || '',
  name_ja: group.get('nameJa') || '',
  name_ru: group.get('nameRu') || '',
  name_zh: group.get('nameZh') || ''
})

const savedSearchIdFrom = payload => (payload && typeof payload === 'object' ? payload.savedSearchId : payload)

export function* saveSavedSearchGroup() {
  try {
    const group = yield select(Selectors.getSelectedSavedSearchGroup)
    const body = groupBody(group)
    let result

    if (group.get('id')) {
      result = yield call(Api.updateSavedSearchGroup, group.get('id'), body)
    } else {
      const moduleName = yield select(Selectors.getViewConfigModuleName)
      body.module_name = moduleName
      result = yield call(Api.createSavedSearchGroup, body)
    }

    yield put(Actions.saveSavedSearchGroupSuccess(result))
    yield put(AppActions.genericSuccessMessage())
  } catch (error) {
    yield put(Actions.saveSavedSearchGroupError(error))
    yield put(AppActions.genericErrorMessage())
    yield put(AppActions.exception(error))
  }
}

export function* deleteSavedSearchGroup() {
  try {
    const group = yield select(Selectors.getSelectedSavedSearchGroup)

    yield call(Api.deleteSavedSearchGroup, group.get('id'))
    yield put(Actions.deleteSavedSearchGroupSuccess(group))
    yield put(AppActions.genericSuccessMessage())
  } catch (error) {
    yield put(Actions.deleteSavedSearchGroupError(error))
    yield put(AppActions.genericErrorMessage())
    yield put(AppActions.exception(error))
  }
}

export function* assignSavedSearchToGroup({ payload }) {
  const savedSearchId = savedSearchIdFrom(payload)

  try {
    const groupId = payload && typeof payload === 'object' && payload.groupId
      ? payload.groupId
      : yield select(Selectors.getAssignSavedSearchesToGroupSelectedGroupId)
    const result = yield call(Api.assignSavedSearchToGroup, groupId, savedSearchId)

    yield put(Actions.assignSavedSearchToGroupSuccess({ groupId, result, savedSearchId }))
  } catch (error) {
    yield put(Actions.assignSavedSearchToGroupError({ error, savedSearchId }))
    yield put(AppActions.genericErrorMessage())
    yield put(AppActions.exception(error))
  }
}

export function* removeSavedSearchFromGroup({ payload }) {
  const savedSearchId = savedSearchIdFrom(payload)

  try {
    const groupId = payload && typeof payload === 'object' && payload.groupId
      ? payload.groupId
      : yield select(Selectors.getAssignSavedSearchesToGroupSelectedGroupId)
    const result = yield call(Api.removeSavedSearchFromGroup, groupId, savedSearchId)

    yield put(Actions.removeSavedSearchFromGroupSuccess({
      groupId,
      id: result.id,
      savedSearchId
    }))
  } catch (error) {
    yield put(Actions.removeSavedSearchFromGroupError({ error, savedSearchId }))
    yield put(AppActions.genericErrorMessage())
    yield put(AppActions.exception(error))
  }
}

export function* watchSaveSavedSearchGroup() {
  yield takeEvery(Actions.saveSavedSearchGroupStart, saveSavedSearchGroup)
}

export function* watchDeleteSavedSearchGroup() {
  yield takeEvery(Actions.deleteSavedSearchGroupStart, deleteSavedSearchGroup)
}

export function* watchAssignSavedSearchToGroup() {
  yield takeEvery(Actions.assignSavedSearchToGroupStart, assignSavedSearchToGroup)
}

export function* watchRemoveSavedSearchFromGroup() {
  yield takeEvery(Actions.removeSavedSearchFromGroupStart, removeSavedSearchFromGroup)
}

export default function* saga() {
  yield all([
    watchSaveSavedSearchGroup(),
    watchDeleteSavedSearchGroup(),
    watchAssignSavedSearchToGroup(),
    watchRemoveSavedSearchFromGroup()
  ])
}
